<script>
  import { Link, useLocation } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";
  import SideNavFlyoutMenu from "./SideNavFlyoutMenu.svelte";

  export let embedded = false;
  export let onNavigate = () => {};

  const location = useLocation();
  const items = [
    { key: "feature-management", label: "Feature Management" },
    { key: "system-operations", label: "System Operations" },
    { key: "access-management", label: "Access Management" },
    { key: "data-management", label: "Data Management" },
    { key: "service-status", label: "Service Status" },
    { key: "platform-setup-test", label: "Platform Setup Test (WIP)" },
    { key: "default-anonymization-rules", label: "Global Anonymization" },
  ];
  let open = false;

  $: currentPath = ($location?.pathname || "").replace(/\/+$/, "");
  $: currentSection = new URLSearchParams($location?.search || "").get("section") || "feature-management";
  $: active = currentPath === ROUTES.admin;
</script>

{#if embedded}
  <details class="admin-settings-section">
    <summary class="side-nav-flyout-item">
      <span class="admin-settings-trigger-icon" aria-hidden="true" />
      <span>Admin Settings</span>
      <img class="admin-settings-chevron" src="/img/assistant/icons/chevron_down_dark.svg" alt="" aria-hidden="true" />
    </summary>
    {#each items as item}
      <Link
        to={`${ROUTES.admin}?section=${item.key}`}
        class={`side-nav-flyout-item${active && currentSection === item.key ? " active" : ""}`}
        aria-current={active && currentSection === item.key ? "page" : undefined}
        on:click={onNavigate}
      >
        {item.label}
      </Link>
    {/each}
  </details>
{:else}
<SideNavFlyoutMenu bind:open {active} align="bottom" ariaLabel="Open Admin Settings menu" tooltip="Admin Settings">
  <svelte:fragment slot="trigger">
    <span class="admin-settings-trigger-icon" aria-hidden="true" />
    <span class="admin-settings-trigger-label">Admin Settings</span>
  </svelte:fragment>
  {#each items as item}
    <Link
      to={`${ROUTES.admin}?section=${item.key}`}
      class={`side-nav-flyout-item${currentSection === item.key ? " active" : ""}`}
      aria-current={currentSection === item.key ? "page" : undefined}
      on:click={() => (open = false)}
    >
      {item.label}
    </Link>
  {/each}
</SideNavFlyoutMenu>
{/if}

<style>
  .admin-settings-section {
    border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
  }

  .admin-settings-section summary {
    list-style: none;
  }

  .admin-settings-section summary::-webkit-details-marker {
    display: none;
  }

  .admin-settings-section .admin-settings-trigger-icon {
    flex-basis: 1rem;
    width: 1rem;
    height: 1rem;
  }

  .admin-settings-section :global(a.side-nav-flyout-item) {
    padding-left: 2.5rem;
  }

  .admin-settings-chevron {
    margin-left: auto;
    width: 0.625rem;
    height: auto;
    flex-shrink: 0;
  }

  .admin-settings-section[open] .admin-settings-chevron {
    transform: rotate(180deg);
  }

  .admin-settings-trigger-icon {
    display: inline-block;
    flex: 0 0 1.25rem;
    width: 1.25rem;
    height: 1.25rem;
    background: var(--pax-black);
    mask: url("/img/assistant/icons/admin_panel.svg") center / contain no-repeat;
    -webkit-mask: url("/img/assistant/icons/admin_panel.svg") center / contain no-repeat;
  }

  .admin-settings-trigger-label {
    display: none;
    overflow: hidden;
    font-size: 0.75rem;
    font-weight: 300;
    line-height: 0.8rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  :global(.app-side-nav.expanded) .admin-settings-trigger-label {
    display: block;
  }
</style>
